// extracted by mini-css-extract-plugin
export default {"body":"Addendum_body__pd3nK"};